import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { track, useTracking } from 'lib/analytics/track'
import { saveOnboardingData, setUserResponse } from '../../actions'
import Slide, { Title } from '../Slide/Slide'
import { ButtonGroup, ButtonRect } from '../OnboardingButtons/OnboardingButtons'
import { HeckYesIcon, NotNowIcon } from 'baby-ui/foundation/BabylistIcons'
import { useNavigate } from 'react-router-dom-v5-compat'

const AddItemsValueProposition = ({
  saveOnboardingData,
  setUserResponse,
  nextPath,
}) => {
  const tracker = useTracking()
  const navigate = useNavigate()

  const userWantsToAddItemsFromAnyStore = (userWantsToAddItemsFromAnyStore) => {
    setUserResponse({ userWantsToAddItemsFromAnyStore })
    navigate(nextPath)
    saveOnboardingData()
  }

  const handleOnClick = (val) => {
    tracker.trackEvent({
      event: track.onboardingQuestionAnswered,
      answer: val ? 'yes' : 'no',
      eventLocation: track.EventLocation.ONBOARDING_MINUS_VALUE_PROPOSITION,
    })
    userWantsToAddItemsFromAnyStore(val)
  }

  return (
    <Slide>
      <Title>
        Did you know that Babylist lets you add items from any store like Etsy,
        Amazon, Target?
      </Title>
      <ButtonGroup>
        <ButtonRect onClick={() => handleOnClick(true)}>
          <HeckYesIcon />
          <div>Yes!</div>
        </ButtonRect>
        <ButtonRect onClick={() => handleOnClick(false)}>
          <NotNowIcon />
          <div>No</div>
        </ButtonRect>
      </ButtonGroup>
    </Slide>
  )
}

export default connect(null, { saveOnboardingData, setUserResponse })(
  AddItemsValueProposition
)
